import { OffsetsBlockSettings, SortingFieldEnum } from '@/dto';
import {
    IOffsetsBlockSettingsChangeServiceData,
} from '../settingsChangeServiceContract';

export class OffsetsBlockSettingsChangeServiceData implements IOffsetsBlockSettingsChangeServiceData {
    public timeOffset: number;
    public alignTimeOffset: number;
    public historyHorizon: number;
    public regularExpressionExternalData: string;
    public formatDate: string;
    public formatTime: string;
    public formatWeight: string;
    public formatVolume: string;
    public formatArea: string;
    public formatCurrency: string;
    public formatNumber: string;
    public siteGroups: string;
    public mapObjectIcons: string;
    public siteIconSizeMultiplier: number;
    public startShiftTime: string;
    public productPackCount: number;
    public orderingField: SortingFieldEnum;
    public urlMap: string;

    constructor(data: OffsetsBlockSettings) {
        this.timeOffset = data.timeOffset || 0;
        this.alignTimeOffset = data.alignTimeOffset || 0;
        this.historyHorizon = data.historyHorizon || 0;
        this.regularExpressionExternalData = data.regularExpressionExternalData || '';
        this.formatDate = data.formatDate || '';
        this.formatTime = data.formatTime || '';
        this.formatWeight = data.formatWeight || '';
        this.formatVolume = data.formatVolume || '';
        this.formatArea = data.formatArea || '';
        this.formatCurrency = data.formatCurrency || '';
        this.formatNumber = data.formatNumber || '';
        this.siteGroups = data.siteGroups || '';
        this.mapObjectIcons = data.mapObjectIcons || '';
        this.siteIconSizeMultiplier = data.siteIconSizeMultiplier || 1;
        this.startShiftTime = data.startShiftTime || '';
        this.productPackCount = data.productPackCount || 0;
        this.orderingField = data.orderingField || -1;
        this.urlMap = data.urlMap || '';
    }
}
